import { put, debounce, select } from 'redux-saga/effects'; // , takeEvery
import * as filtersActions from '../actions/filters';
import * as ordersActions from '../actions/orders';

function* updateFilterFieldsSaga() {
  const filters = yield select(state => state.Executorship.Orders.filters);
  // const ordersFilters = yield select(state => state.Executorship.Orders.orders.filters);
  let countFilters = 0;
  // let filterTypeList = false;
  if (filters.search && filters.search.length > 1) {
    countFilters++;
  }
  /*if (filters.typeList && filters.typeList !== 'all') {
    countFilters++;
    filterTypeList = true;
  }*/
  if (filters.fields) {
    countFilters += Object.keys(filters.fields).length;
  }
  if (filters.count !== countFilters) {
    yield put(filtersActions.countFiltersOrders(countFilters));
  }
  // if (filterTypeList && countFilters > 1 || !filterTypeList && countFilters > 0) {
  if (countFilters > 0) {
    yield put(ordersActions.getFilterOrders(filters));
  } else {
    yield put(ordersActions.getAllOrders());
  }
}

export function* filtersConfigWatcher() {
  yield debounce(
    600,
    [
      filtersActions.updateFilterFieldsOrders.toString(),
      filtersActions.searchOrders.toString(),
    ],
    updateFilterFieldsSaga
  );
  /*yield takeEvery(
    filtersActions.changeTypeListOrders.toString(),
    changeTypeListOrdersSaga
  );*/
}
